import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { TeamService } from 'src/app/shared/services/team.service';
import { Team } from 'src/app/shared/models/team/team';
import { Position } from 'src/app/shared/models/team/position';
import { TeamWrite } from 'src/app/shared/models/team/teamWrite';
import { PositionWrite } from 'src/app/shared/models/team/positionWrite';
import { NotEmptyValidator } from 'src/app/shared/validators/not-empty.validator';

import * as _ from 'lodash';

@Component({
  selector: 'position-details',
  templateUrl: 'position-details.component.html',
  styleUrls: ['./position-details.component.scss'],
})
export class PositionDetailsComponent implements OnInit, OnDestroy {
  private sub;
  teamForm: UntypedFormGroup;
  positionForm: UntypedFormGroup;
  errorMessage: any;
  team: Team;
  @Input() position: Position;
  teamWrite: TeamWrite;
  positionWrite: PositionWrite;

  constructor(
    private teamService: TeamService,
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<PositionDetailsComponent>
  ) {}

  ngOnInit() {
    this.buildPositionForm();
  }

  buildPositionForm() {
    this.positionForm = this.formBuilder.group({
      title: [
        this.position ? this.position.title : '',
        NotEmptyValidator('Position title is required'),
      ],
      seatCount: [
        this.position ? this.position.seatCount : 1,
        [Validators.required, Validators.min(1)],
      ],
      description: [this.position ? this.position.description : '', Validators.maxLength(500)],
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  savePosition() {
    this.sub = this.teamService.team.subscribe(
      (team) => {
        if (team) {
          this.team = team;
          this.dialogRef.close('yes');
        }
      },
      (error) => (this.errorMessage = <any>error)
    );

    this.assignFormValuesToPosition();
    this.teamService.updatePosition(this.team.id, this.positionWrite);
  }

  createPosition() {
    this.sub = this.teamService.team.subscribe(
      (team) => {
        if (team) {
          this.team = team;
          this.dialogRef.close('yes');
        }
      },
      (error) => (this.errorMessage = <any>error)
    );
    this.assignFormValuesToPosition();
    this.teamService.createPosition(this.team.id, this.positionWrite);
  }

  assignFormValuesToPosition(): void {
    const positionFormModel = this.positionForm.value;

    var title = positionFormModel.title;
    var description = positionFormModel.description;
    var seats = positionFormModel.seatCount;

    this.positionWrite = new PositionWrite(
      title,
      seats,
      this.position ? this.position.id : null,
      description
    );
  }
}
